import { CheckIcon } from '@heroicons/react/outline'
import React, { FC, useState, useEffect } from 'react'
import { StyledPromoCodeInput } from '.'

import { Button, LabelWrapper, LineInput } from '../System'
import useCart from '../../redux/shopping-cart/useCart'
import usePromoCode from './usePromoCode'

type PromoChange = {
  stripeID: string;
  promoCode: string;
  discountAmount: number;
  newTotal: number;
}

type PromoCodeInputProps = {
  onChange: (e: PromoChange) => any;
  totalCost: number;
}

const PromoCodeInput: FC<PromoCodeInputProps> = ({ onChange, totalCost }) => {
  const { validatePromoCode } = usePromoCode()
  const { actions: { calculateDiscount } } = useCart()

  const [validatedCode, setValidatedCode] = useState(false)
  const [promoCode, setPromoCode] = useState('')
  const [promoCodeError, setPromoCodeError] = useState('')

  const handlePromoCodeValidation = async () => {
    try {
      const responseCode = await validatePromoCode(promoCode)
      setValidatedCode(true)
      setPromoCodeError('')

      const discountAmount = calculateDiscount(responseCode.type, responseCode.amount, totalCost)
      const newTotal = Math.max(0, totalCost - discountAmount)

      onChange({
        stripeID: responseCode.stripeID,
        promoCode: responseCode.code,
        discountAmount,
        newTotal
      })
    }
    catch (err) {
      setPromoCodeError(err.message)
    }
  }

  useEffect(() => {
    if (validatedCode) {
      handlePromoCodeValidation()
    }
  }, [totalCost])

  return (
    <StyledPromoCodeInput>
      <LabelWrapper
        label="Promo Code"
        errorIsInline
        errorMessage={promoCodeError}
        className="promo-input"
      >
        <LineInput isDisabled={validatedCode} onChange={(e) => setPromoCode(e.target.value)} />
      </LabelWrapper>
      <Button
        onClick={() => handlePromoCodeValidation()}
        isDisabled={!promoCode.trim() || validatedCode}
        type="small"
        theme="solid"
        hasIcon={validatedCode}
        iconPos="right"
      >
        {!validatedCode ? (
          'Apply'
        ) : (
            <>
              Applied <CheckIcon />
            </>
          )}
      </Button>
    </StyledPromoCodeInput>
  )
}

export default PromoCodeInput
